export default {
  type: '',
  url: ''
}
